import {
    Box,
    MenuItem,
    Autocomplete as MuiAutocomplete,
    TextField,
    createFilterOptions,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { Translations } from "ui/Scripts/source/models/translations";

interface AutocompleteProps {
  value: string;
  maxLength: number;
  options: IIdTitle[];
  onChange: (value: string) => void;
}

const filter = createFilterOptions<IIdTitle>();

export const Autocomplete = ({
    value = "",
    options,
    maxLength,
    onChange,
}: AutocompleteProps) => {
    const unfilteredValue = useRef("");

    useEffect(() => {
        unfilteredValue.current = value;
    }, [value]);

    return (
        <MuiAutocomplete
            value={value}
            onChange={(_event, newValue) => {
                if (typeof newValue === "string") {
                    onChange(value);
                } else {
                    onChange(newValue?.id);
                }
            }}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === "Tab") {
                    if (!unfilteredValue.current) return;
                    //event.defaultMuiPrevented = true;
                    onChange(unfilteredValue.current);
                }
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                const isExisting = options.some((option) => inputValue === option.title);
                if (inputValue !== "" && !isExisting) {
                    unfilteredValue.current = inputValue;
                    filtered.push(
                        new IdTitle({
                            id: inputValue,
                            title: `${Translations.Add} "${inputValue}"`,
                        } as IIdTitle)
                    );
                }

                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            options={options}
            getOptionLabel={(option) => {
                if (typeof option === "string") {
                    return option;
                }
                if (option.id) {
                    return option.id;
                }
                return option.title;
            }}
            renderOption={(props, option) => {
                if (option.title !== `${Translations.Add} "${option.id}"`) {
                    return <MenuItem {...props}>{option.title}</MenuItem>;
                } else {
                    return <MenuItem {...props}><Box sx={{ fontWeight: "bold", marginRight: ".5rem" }}>{Translations.Add}</Box>{`"${option.id}"`}</MenuItem>;
                }
            }}
            freeSolo
            renderInput={(params) => (
                <TextField inputProps={{ maxLength }} fullWidth {...params} />
            )}
        />
    );
};
